import React, { useEffect } from "react";
import { Form } from "reactstrap";

import useCurrentCustomerStore from "../../../../../stores/CustomerStore";
import InputElement, {
	ZipInputElement2,
} from "../../../../forms/components/InputElement";
import InputWrapper from "../../../../forms/components/InputWrapper";

import { CountryCodes, stateOptions } from "../../../../../constants/Constants";
import { SelectorElement } from "../../../../forms/components/InputElement";

import { useFormContext } from "react-hook-form";

const MailingAddress = ({ getMailCities, sameAsCurrent }) => {
	const {
		mailingAddress,
		currentAddress,
		editMailingAddress,
		editMailingAddressValue,
	} = useCurrentCustomerStore((state) => ({
		mailingAddress: state.mailingAddress,
		currentAddress: state.currentAddress,
		editMailingAddress: state.editMailingAddress,
		editMailingAddressValue: state.editMailingAddressValue,
	}));

	const isInternational =
		mailingAddress.country && mailingAddress.country !== "USA";
	const zipLabel = isInternational ? "Postal Code" : "Zip";
	const countyLabel = isInternational ? "Province/Governorate" : "County";

	const handleZipChange = (zip) => {
		const updatedAddress = {
			...mailingAddress,
			street: methods.getValues("mailStreet"),
			unit: methods.getValues("mailUnit"),
			city: methods.getValues("mailCity"),
			state: methods.getValues("mailState"),
			zip: methods.getValues("mailZip"),
			county: methods.getValues("mailCounty"),
			country: mailingAddress.country || "USA",
		};
		getMailCities(zip, updatedAddress);
	};

	useEffect(() => {
		if (sameAsCurrent) {
			editMailingAddress({
				...currentAddress,
				isMailingAddress: true,
				isCurrent: false,
			});
		}
		// eslint-disable-next-line
	}, [sameAsCurrent]);

	const methods = useFormContext();

	return (
		<Form>
			<InputWrapper
				formTitle="Mailing Address"
				inputComponents={[
					<InputElement
						{...methods}
						disabled={sameAsCurrent}
						value={mailingAddress.street || ""}
						onChange={(e) =>
							editMailingAddressValue({
								street: e.target.value,
							})
						}
						name="mailStreet"
						label="Street Address"
						type="text"
					/>,
					<InputElement
						{...methods}
						disabled={sameAsCurrent}
						value={mailingAddress.unit || ""}
						onChange={(e) =>
							editMailingAddressValue({
								unit: e.target.value,
							})
						}
						name="mailUnit"
						label="Apt/Unit/Bld"
						type="text"
					/>,
					<InputElement
						{...methods}
						disabled={sameAsCurrent}
						value={mailingAddress.city || ""}
						onChange={(e) =>
							editMailingAddressValue({
								city: e.target.value,
							})
						}
						name="mailCity"
						label="City"
						type="text"
					/>,
					<SelectorElement
						{...methods}
						disabled={sameAsCurrent}
						value={mailingAddress.country || "USA"}
						onChange={(e) =>
							editMailingAddressValue({
								country: e.target.value,
							})
						}
						name="mailCountry"
						label="Country"
						options={CountryCodes}
					/>,
					!isInternational && (
						<SelectorElement
							{...methods}
							disabled={sameAsCurrent}
							name="mailState"
							label="State"
							value={mailingAddress.state || ""}
							onChange={(e) =>
								editMailingAddressValue({
									state: e.target.value,
								})
							}
							options={stateOptions}
						/>
					),
					<ZipInputElement2
						{...methods}
						disabled={sameAsCurrent}
						value={mailingAddress.zip || ""}
						onChange={(zip) =>
							editMailingAddressValue({
								zip,
							})
						}
						openZipModal={handleZipChange}
						name="mailZip"
						label={zipLabel}
						isInternational={isInternational}
					/>,
					<InputElement
						{...methods}
						disabled={sameAsCurrent}
						value={mailingAddress.county || ""}
						onChange={(e) =>
							editMailingAddressValue({
								county: e.target.value,
							})
						}
						name="mailCounty"
						label={countyLabel}
						type="text"
					/>,
				]}
			/>
		</Form>
	);
};

export default MailingAddress;
